// Canonical legal URLs. The privacy policy is served by the app itself so it is
// always available offline-of-marketing-site and identical in the app and on the web.
export const PRIVACY_POLICY_URL = "/privacy";
export const TERMS_URL = "/terms";
export const REFUNDS_URL = "/refunds";
export const ACCOUNT_DELETION_URL = "/account/delete";
export const SUPPORT_EMAIL = "info@theastrofate.com";
